module.exports = __webpack_public_path__ + "flatfair_logo_blue.708d258c8d5d74fa06b7f9be8f346332.png";